// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"c5d2aa50","209":"7a2b3d83","457":"bd9d1a8a","484":"37c11083","570":"596269fd","851":"65ec1ca3","940":"c899fb11","974":"3e5d5079"}[chunkId] + ".chunk.js";
};